<template>
  <div class="user-list">
    <el-form :inline="true" class="demo-form-inline" v-loading="loading" size="mini">
      <!--<el-form-item>-->
      <!--<el-input v-model="search" placeholder="输入名字查询" size="small"></el-input>-->
      <!--</el-form-item>-->
      <el-form-item>
        <el-button-group>
          <!--<el-button type="primary" @click="fetch" size="mini">查询</el-button>-->
          <el-button @click="dialogFormVisible=true" size="mini">增加</el-button>

        </el-button-group>
      </el-form-item>
    </el-form>

    <el-dialog title="新增用户" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="用户名">
          <el-input v-model="form.username" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="form.password" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetDialogForm">取 消</el-button>
        <el-button type="primary" @click="addUser">确 定</el-button>
      </div>
    </el-dialog>

    <el-table :data="list" size="mini">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" label-width="80px">
            <el-form-item label="用户名">
              <el-input v-model="props.row.username" size="mini"/>
            </el-form-item>
            <el-form-item label="邮箱">
              <el-input v-model="props.row.email" size="mini"/>
            </el-form-item>
            <el-form-item label="密码">
              <el-input v-model="props.row.password" size="mini" type="password"/>
            </el-form-item>
            <el-form-item label="lock">
              <el-radio-group v-model="props.row.locked" size="mini">
                <el-radio-button label="1" size="mini">lock</el-radio-button>
                <el-radio-button label="0" size="mini">unlock</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="角色">
              <el-transfer :titles="['角色列表', '已有角色']" v-model="props.row.r" :data="roles"></el-transfer>
            </el-form-item>
            <el-form-item>
              <el-button @click="update(props.row, props.$index)" size="mini" type="primary">更新</el-button>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column prop="username" label="用户名"></el-table-column>
      <el-table-column prop="locked" label="locked">
        <template slot-scope="scope">
          {{scope.row.locked==1 ? '是' : '否'}}
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <el-button-group size="mini" label="操作">
            <el-button size="mini" type="danger" @click="remove(scope.row)">删除</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <br/>
    <div style="float: right">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="i=>page=i"
        :page-size="20"
        :page-count="page"
        :total="total">
      </el-pagination>
    </div>

  </div>
</template>

<script>
  import request from '../request'
  import map from '../../datamap'
  import api from '../api'

  const {sysuser, role, per} = api

  export default {
    name: 'user-list',
    data () {
      return {
        loading: true,
        search: '',
        list: [],
        roles: [],
        total: 0,
        page: 1,
        dialogFormVisible: false,
        form: {
          username: '',
          password: '',
        },
        originList: [],
      }
    },
    watch: {
      page () {
        this.fetch()
      },
    },
    methods: {
      async fetch () {
        let pageNum = this.page
        this.loading = true

        let res = await sysuser.list({start: (pageNum - 1) * 20, locked: '0'})
        let {code} = res.data

        let list = res.data.data.map((item) => {
          item.roles = item.roles || []
          item.r = item.roles.map((i) => {
            return i.roleId
          })
          return item
        })
        this.list = list
        this.originList = JSON.parse(JSON.stringify(list))
        this.loading = false
        this.total = res.data.pageinfo.totalCount
      },

      async add () {
        let {value} = await this.$prompt('请输入用户名', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
        let res = await sysuser.post({
          username: value,
          password: '123456',
          locked: 0,
        })
        let {code} = res.data
        if (code === 200) {
          this.$message.success('增加用户成功')
        }
        this.fetch()
      },

      async addUser () {
        const {data: {code}} = await sysuser.post({
          username: this.form.username,
          password: this.form.password,
          locked: 0,
        })
        if (code === 200) {
          this.$message.success('增加用户成功')
          this.resetDialogForm()
        }
        this.fetch()
      },

      async fetch_role () {
        let res = await role.list()
        res = res.data.data.map((item) => {
          item.key = item.roleId
          item.label = item.roleName
          return item
        })
        this.roles = res
      },

      async update (obj, index) {
        const data = JSON.parse(JSON.stringify(obj))
        data.roleIds = Array.isArray(data.r) ? data.r.join(',') : ''
        if (data.password === this.originList[index].password) {
          delete data.password
        }
        delete data.roles
        delete data.r
        delete data.updateTime
        delete data.createTime
        let res = await sysuser.update(data)
        if (res.data.code === 200) {
          this.$message.success('成功更新用户')
          this.fetch()
        }
      },

      async remove (obj) {

        try {
          await this.$confirm(' 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
          let res = await sysuser.remove({userId: obj.id})

          let {code} = res.data
          if (code === 200) {
            this.$message.success('删除用户成功')
            this.fetch()
          }

        } catch (e) {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        }

      },

      resetDialogForm () {
        this.form.username = ''
        this.form.password = ''
        this.dialogFormVisible = false
      },

    },
    mounted () {
      this.fetch()
      this.fetch_role()
    },
  }
</script>

<style>
  .user-list {
  }
</style>



// WEBPACK FOOTER //
// src/views/sysuser/sysuser-list.vue